@import 'styles/mixins';
@import 'styles/variables';

.disabledInput {
  border-radius: 4px;
  padding: 5px 12px;
  height: 32px;
  width: 100%;
  border: 1px solid var(--dark-8);
  background-color: white;
  color: var(--dark-40);
}
